export enum CoupaPurchaseLineType {
    ORDER_AMOUNT_LINE = 'OrderAmountLine',
    ORDER_QUANTITY_LINE = 'OrderQuantityLine',
    REQUEST_AMOUNT_LINE = 'RequisitionAmountLine',
    REQUEST_QUANTITY_LINE = 'RequisitionQuantityLine',
}
